import React from 'react';
import Loading from './Loading';
import PropTypes from 'prop-types';

const LoadingInspector = ({ loading, children, ...props }) => {
    return (
        <div {...props} className="loading-instance-wrapper">
            { loading && <Loading className="loading-spacer" />}
            {children}
        </div>
    );
};

LoadingInspector.propTypes = {
    children: PropTypes.node,
    loading: PropTypes.bool
};

export default LoadingInspector;
